<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card class="sb-info-block">
        <md-card-content>
          <slot/>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>

export default {
    name: 'SidebarInfoBlock',
}
</script>
<style lang="scss" scoped>
  .sb-info-block {
    margin: 10px 0;
  }
</style>
